<div class="content">


  <div class="subheader-text">
    <span class="subheader">Checklist Templates</span>
  </div>
  <div class="group" *ngFor="let checklistTemplate of checklistTemplates">
    <div class="group-content">
      <div class="group-avatar"[style.background-color]="getColorFromName(checklistTemplate.name)">{{checklistTemplate.name.substring(0,1)}}</div>
      <div class="group-text">
        <div class="group-name">{{checklistTemplate.name}}</div>
        <div class="group-desc">{{getItemsAsString(checklistTemplate)}}</div>
      </div>
    </div>
    <div class="action-buttons">
      <button  (click)="editChecklistTemplate(checklistTemplate)" mat-icon-button >
        <mat-icon>edit_outline</mat-icon>
      </button>
      <button  (click)="deleteChecklistTemplate(checklistTemplate)" mat-icon-button >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
  </div>
  <div class="add-new-container">
    <button mat-fab color="primary" (click)="editChecklistTemplate({})">
  + Add new
    </button>
  </div>

</div>
